import React, {Component} from 'react'
import {connect} from 'react-redux'
import 'css/trialended.less'

class TrialEnded extends Component {

	constructor(props) {
		super(props)
	}

	render() {
		return (
			<div className='container-fluid trial'>
				<div className='col-xs-12 col-md-10 col-md-offset-1'>
					<div className='panel'>
						<div className='panel-body'>
							<div className='row'>
								<div className='col-md-12 col-xs-12 col-sm-12'>
									<h2 className='text-center primary'>Edgebet is becoming <a href='http://tradematesports.com' target='_blank'>Trademate</a></h2>
								</div>
								<div className='col-md-12 col-xs-12 col-sm-12'>
									<p className='extra-sentence'>Edgebet is migrating to to <a href='http://tradematesports.com' target='_blank'>Trademate</a>. As such, your current subscription on Edgebet has now expired. Don't worry, if you have time left on your Edgebet subscription, you will be able to use Trademate until your current Edgebet subscription period comes to an end. Trademate is a revamped and improved version of Edgebet. Complete with a faster odds engine, multi tradefeed options, new construcitve analysis tools and a strongly engaged community for users to communicate and swap ideas. We are streaming live trading sessions 6 days a week in a project we call <a href='https://www.twitch.tv/tradingasia' target='_blank'>Trading Asia </a>. All previous streams are available on our <a href="https://www.youtube.com/watch?v=gXG56feiqKY">YouTube Channel</a>. Also on the YouTube channel you can watch the product walkthroughs for our two new product offerings, <a href="https://www.youtube.com/channel/UCwb59a_gp2TmoeJgl6xTHOg" target='_blank'>Trademate Core</a> and <a href="https://www.youtube.com/watch?v=5IGYc0N3CQE" target='_blank'>Trademate Pro</a> As always, if you have any questions, don't hesitate to reach out to us through the question mark in the bottom right corner, or go to <a href='https://tradematesports.com' target='_blank'>tradematesports.com</a>. All your exisiting Edgebet data can be transfered to your new Trademate account.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

}

export default connect(state => {
	return {
		userbets: state.userbets,
		currencies: state.currencies
	}
})(TrialEnded)



/** WEBPACK FOOTER **
 ** ./src/components/TrialEnded.js
 **/